import { PrimeIcons } from "primeng/api"

import { LgkNavMenuItem } from "@logick/ui/api"

export const ANALYTICS_MENU: LgkNavMenuItem = {
    label: "Suivi",
    icon: PrimeIcons.CHART_BAR,
    routerLink: "analytics",
    items: [
        {
            label: "Programmation",
            type: "section",
            items: [
                {
                    label: "Evénements",
                    routerLink: "events",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./ticketing/show-dashboard/show-dashboard.page").then(it => it.ShowDashboardPage) }
                },
                {
                    label: "Représentations",
                    routerLink: "sessions",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./ticketing/ticketing-sales.page").then(it => it.TicketingSalesPage) }
                },
                {
                    label: "Cinémas",
                    routerLink: "cinemas",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./ticketing/voucher-dashboard/voucher-dashboard.page").then(it => it.VoucherDashboardPage) }
                },
                {
                    label: "Bons d'achat",
                    routerLink: "multi-partner-vouchers",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./ticketing/multi-partner-voucher-dashboard/multi-partner-voucher-dashboard.page").then(it => it.MultiPartnerVoucherDashboardPage) }
                }
            ]
        }, {
            label: "Billets",
            type: "section",
            items: [
                {
                    label: "Contrôles",
                    routerLink: "ticket-control",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./ticket-control/ticket-control.page").then(it => it.TicketControlPage) }
                 }
            ]
        },
        {
            label: "CRM",
            type: "section",
            items: [
                {
                    label: "Activités",
                    routerLink: "contact-activities",
                    featureState: { isLocked: true }
                 },
                {
                    label: "Fréquentation",
                    routerLink: "freq",
                    featureState: { isLocked: true }
                },
                {
                    label: "Géographique",
                    routerLink: "geo",
                    featureState: { isLocked: true }
                },
            ]
        },
        {
            label: "Comptabilité",
            type: "section",
            items: [
                {
                    label: "Rapports de ventes",
                    routerLink: "sales-reports",
                    featureState: { isLocked: false },
                    routing: {
                        loadComponent: () => import("./sales-reports/sales-reports.page").then(it => it.SalesReportsPage),
                        children: [
                            { path: "", pathMatch: "full", redirectTo: "balance" },
                            { path: "balance", loadComponent: () => import("./balance/balance-sheet.page").then(it => it.BalanceSheetPage) },
                            { path: "carts", loadComponent: () => import("./carts-report/carts-report.page").then(it => it.CartsReportPage) },
                            { path: "orders", loadComponent: () => import("./orders-report/orders-report.page").then(it => it.OrdersReportPage) },
                            { path: "payments", loadComponent: () => import("./payments-report/payments-report.page").then(it => it.PaymentsReportPage) },
                            { path: "accounting", loadComponent: () => import("./accounting-report/accounting-report.page").then(it => it.AccountingReportPage) }
                        ]
                    }
                }, {
                    label: "Bordereau de vente",
                    routerLink: "partners",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./partners/partner-sales-report.page").then(it => it.PartnerSalesReportPage) }
                },
                {
                    label: "Télécollectes",
                    routerLink: "payment-settlements",
                    featureState: { isLocked: false },
                    routing: { loadComponent: () => import("./payment-settlement/payment-settlement.page").then(it => it.PaymentSettlementPage) }
                },
            ]
        }
    ]
}
